import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Row,
  Col,
  Table,
  Button,
  Badge,
  Card,
  CardHeader,
  Input,
  Modal,
} from "reactstrap";
import {
  assignRequestToReviewerApi,
  changePublishRequestStatus,
  getPublishRequestApi,
  joinedAllJournalsApi,
  razorpayApi,
  updatePRDocumentApi,
} from "src/network/api";
import LoaderComponent from "src/pages/components/LoaderComponent";
import PageLayout from "src/pages/PageLayout";
import { useAppSelector } from "src/state/store/store";
import {
  getApprovalStatusPill,
  getPaymentStatusPill,
  getPRStatusPill,
} from "src/utils/appUtils";

// Declare Razorpay on the window object
declare global {
  interface Window {
    Razorpay: any;
  }
}

const PublishRequests = () => {
  const [data, setData] = useState([]);
  const user = useAppSelector((state) => state.auth.user);
  const [reviewers, setReviewers] = useState([]);
  const [filteredReviewers, setfilteredReviewers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [targetRequest, setTargetRequest] = useState(null);
  const [targetReviewer, setTargetReviewer] = useState(0);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("non-published");

  useEffect(() => {
    fetchData();
  }, [statusFilter]);
  useEffect(() => {
    fetchReviewers();
  }, []);

  useEffect(() => {
    setTargetReviewer(0);
    setfilteredReviewers(
      reviewers.filter((item) => item.journal_id == targetRequest?.journal_id)
    );
  }, [targetRequest]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getPublishRequestApi(statusFilter);
      setData(response.data.data);
    } catch (e) {
      toast.error(e.response?.data?.message ?? e.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchReviewers = async () => {
    try {
      const response = await joinedAllJournalsApi();
      setReviewers(
        Array.isArray(response.data?.data) ? response.data.data : []
      );
    } catch (err) {
      console.error("Error fetching reviewers:", err);
      setReviewers([]);
    }
  };

  const handleModal = () => {
    setShowModal(false);
    setTargetReviewer(0);
  };

  const handleStatusUpdate = async (req_id, approval_status, liveUrl) => {
    const confirmAction = window.confirm(
      `Are you sure you want to ${approval_status.replace(
        "_",
        " "
      )} this request?`
    );
    if (!confirmAction) return;

    try {
      const formdata = new FormData();
      formdata.append("status", approval_status);
      formdata.append("live_url", liveUrl);

      const response = await changePublishRequestStatus(req_id, formdata);

      if (response.status == 200 && response.data.status === 200) {
        toast.success(
          response.data?.message || "Request status updated successfully."
        );
        fetchData();
      } else {
        toast.error(
          response.data.message || "Failed to update request status."
        );
      }
    } catch (e) {
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  const handlePayment = async (request) => {
    console.log(request);
    const pr_id = request.pr_id;

    try {
      const response = await razorpayApi(pr_id);

      if (response.status === 200 && response.data.status === 200) {
        const orderId = response.data.data.order_id;
        const amount = response.data.amount;
        console.log(response);
        console.log(orderId);
        initiateRazorpayPayment(orderId, amount);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Submission failed. Please try again.");
    }
  };

  const initiateRazorpayPayment = async (order_id: any, amount: number) => {
    try {
      const options = {
        key: "rzp_test_lo1DpXawQRBUZe",
        amount: amount * 100, // Amount in paise (multiply by 100)
        currency: "INR",
        name: "IFRJ Index",
        description: "Publish Paper",
        order_id: order_id, // Must be generated from backend
        handler: async function (response) {
          // try {
          //   await changePublishRequestStatus(pr_id, {
          //     razorpay_order_id: response.razorpay_order_id,
          //     razorpay_payment_id: response.razorpay_payment_id,
          //   });
          //   toast.success("Payment successful!");
          // } catch (error) {
          //   console.error("Error verifying payment:", error);
          //   toast.error("Payment verification failed.");
          // }
        },
        prefill: {
          name: user.name || "User",
          email: user.email || "user@example.com",
          contact: user.contact || "9999999999",
        },
        theme: { color: "#3d4a9c" },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      toast.error("Failed to initiate payment. Please try again.");
    }
  };

  const handleUpload = async (e) => {
    let file = e.target.files[0];
    let targetPR = e.target.dataset.prId;
    if (!file) {
      toast.error("Please select a file first.");
      return;
    }
    if (!targetPR) {
      toast.error("No target publish request.");
      return;
    }

    const formData = new FormData();
    formData.append("prId", targetPR);
    formData.append("file", file);

    try {
      const response = await updatePRDocumentApi(formData);
      if (response.status == 200 && response.data.status == 200) {
        toast.success("Document Updated Successfully.");
      } else {
        toast.error(response.data?.message);
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error?.response?.data?.message || error.message);
    }
  };

  function updateDocument(prId) {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "doc/*";
    fileInput.dataset.prId = prId;
    fileInput.onchange = handleUpload;
    fileInput.click();
  }

  return (
    <PageLayout>
      <div className="mt-5 container-fluid">
        <Row>
          <Col lg="12" className="mb-1">
            <Card className="shadow-sm">
              <CardHeader className="bg-primary">
                <h3 className="mb-0 text-center font-weight-bold text-white py-2">
                  Publish Requests
                </h3>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mb-3">
          <div className="d-flex flex-row align-items-center">
            Show:
            <select
              className="form-control mx-2"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value={"all"}>All</option>
              <option value={"non-published"}>Non Published</option>
              <option value={"published"}>Published</option>
              <option value={"rejected"}>Rejected</option>
            </select>
          </div>
        </div>
        <Row>
          <Col lg="12">
            <Table bordered hover responsive className="mb-5" size="sm">
              <thead className="thead-light">
                <tr>
                  <th>ReqID</th>
                  <th>Paper Title</th>
                  <th>Subject</th>
                  <th>Keywords</th>
                  <th>Journal Name</th>
                  <th>Author Name</th>
                  <th>Payment Status</th>
                  <th>Request Status</th>
                  <th>Live Link </th>
                  <th>Sender</th>
                  <th>Created At</th>
                  <th>Actions</th>

                  {user.type === "publisher" && (
                    <>
                      <th>Assigned Reviewer</th>
                      <th>Reviewer Remarks</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {!loading &&
                  data &&
                  data.map((request) => {
                    const isAuthor = user.type === "author";
                    const isPublisher = user.type === "publisher";
                    const isSender = user.type === request.sender;
                    return (
                      <tr key={request.id}>
                        <td>{request.pr_id}</td>
                        <td>{request.paper_title}</td>
                        <td>{request.subjects}</td>
                        <td>{request.keywords}</td>
                        <td>{request.journal_name}</td>
                        <td>{request.author_name}</td>
                        <td>{getPaymentStatusPill(request.payment_status)}</td>
                        <td>
                          {request.pr_status === "accept" &&
                          user.type === "author" &&
                          request.assigned_reviewer != "0"
                            ? "In Review"
                            : getPRStatusPill(request.pr_status)}
                        </td>
                        <th>
                          {request.live_url && (
                            <a href={request.live_url}>{request.live_url}</a>
                          )}
                        </th>
                        <td style={{ textTransform: "capitalize" }}>
                          {isSender ? "You" : request.sender}
                        </td>
                        <td>{request.created_at || "N/A"}</td>
                        <td>
                          <div className="d-flex justify-content-around">
                            {/* Pending status actions */}
                            {request.pr_status === "pending" && !isSender && (
                              <>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    handleStatusUpdate(
                                      request.pr_id,
                                      "accept",
                                      ""
                                    )
                                  }
                                >
                                  Approve
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() =>
                                    handleStatusUpdate(
                                      request.pr_id,
                                      "reject",
                                      ""
                                    )
                                  }
                                >
                                  Reject
                                </Button>
                              </>
                            )}
                            {/* Accepted status actions for publishers */}
                            {request.pr_status === "accept" && isPublisher && (
                              <>
                                <a
                                  target="_blank"
                                  className="btn btn-primary btn-sm d-flex align-items-center"
                                  href={request.file}
                                >
                                  Download
                                </a>
                                <a
                                  target="_blank"
                                  className="btn btn-info btn-sm d-flex align-items-center"
                                  onClick={() => updateDocument(request.pr_id)}
                                >
                                  Update Document
                                </a>
                                <Button
                                  color="warning"
                                  size="sm"
                                  onClick={() => {
                                    setShowModal(true);
                                    setTargetRequest(request);
                                  }}
                                >
                                  Assign to Reviewer
                                </Button>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    handleStatusUpdate(
                                      request.pr_id,
                                      "proceed_payment",
                                      ""
                                    )
                                  }
                                >
                                  Proceed Payment
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() =>
                                    handleStatusUpdate(
                                      request.pr_id,
                                      "reject",
                                      ""
                                    )
                                  }
                                >
                                  Reject
                                </Button>
                              </>
                            )}
                            {/* Proceed Payment actions */}
                            {request.pr_status === "proceed_payment" &&
                              user.type === "author" &&
                              request.payment_status !== "complete" && (
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handlePayment(request)}
                                >
                                  Pay Now
                                </Button>
                              )}

                            {/* Proceed Payment actions */}
                            {request.pr_status === "proceed_payment" &&
                              isPublisher && (
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => {
                                    const liveUrl = prompt("Enter Live URL:");
                                    console.log(liveUrl);
                                    if (!liveUrl) {
                                      alert(
                                        "Live URL is mandatory. Please provide a valid URL."
                                      );
                                      return;
                                    }
                                    handleStatusUpdate(
                                      request.pr_id,
                                      "published",
                                      liveUrl
                                    );
                                  }}
                                >
                                  Publish
                                </Button>
                              )}
                          </div>
                        </td>
                        {isPublisher && (
                          <>
                            <td>
                              {request.reviewer_name ? (
                                request.reviewer_name
                              ) : (
                                <Badge
                                  color="warning"
                                  style={{ color: "white" }}
                                >
                                  Not Assigned
                                </Badge>
                              )}
                            </td>
                            <td>{request.reviewer_remarks}</td>
                          </>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </Table>

            {loading ? (
              <p className="mb-5 text-center">Please wait</p>
            ) : data?.length == 0 ? (
              <p className="mb-5 text-center">No Records to show</p>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
      <Modal
        className="modal-dialog-centered"
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            Assign to Reviewer
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Choose a Reviewer</label>
            <Input
              type="select"
              onChange={(e) => setTargetReviewer(parseInt(e.target.value))}
            >
              <option value={0}>Select Reviewer</option>
              {Array.isArray(filteredReviewers) &&
                filteredReviewers.map((reviewer) => {
                  if (reviewer.journal_id != targetRequest?.journal_id)
                    return null;
                  return (
                    <option key={reviewer.id} value={reviewer.id}>
                      {reviewer.name}
                    </option>
                  );
                })}
            </Input>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            color="primary"
            type="button"
            disabled={
              targetReviewer === 0 ||
              !targetRequest?.pr_id ||
              targetRequest.pr_id === 0
            }
            onClick={async () => {
              try {
                const response = await assignRequestToReviewerApi(
                  targetReviewer,
                  targetRequest.pr_id
                );

                if (response.status === 200 && response.data.status === 200) {
                  toast.success(response.data.message);
                } else {
                  toast.error(response.data.message);
                }
              } catch (err) {
                console.error("Error sending request:", err);
                toast.error(err.response?.data?.message ?? err.message);
              } finally {
                setShowModal(false);
              }
            }}
          >
            Assign to Reviewer
          </Button>

          <Button
            className="ml-auto"
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={handleModal}
          >
            Close
          </Button>
        </div>
      </Modal>
    </PageLayout>
  );
};

export default PublishRequests;
